import React from 'react';
import { NextPageContext } from 'next';

import { Breadcrumbs, HeroStatic, StudentCard } from '../../../components';
import { useSiteQuery } from '../../../hooks';
import ErrorPage from '../../_error';
import NotFoundPage from '../../404';

import query from './index.graphql';

interface Props {
  slug: string;
}

const StudentInformationPage = ({ slug }: Props) => {
  const [{ data, error }] = useSiteQuery<StudentInformationQuery>({ query, variables: { slug } });

  if (error) {
    return <ErrorPage statusCode={500} err={error} />;
  }

  const entry = data?.entry;
  const entries = data?.entries;

  if (entry) {
    const title = entry.title!;
    const uri = entry.uri!;
    const heroImage = entry.heroImage;
    const moreItems = entries?.filter((item) => item?.slug !== entry.slug!).slice(0, 3);

    const breadcrumbs: BreadcrumbItem[] = [
      { title: 'Student Information', uri: '/student-information' },
      { title, uri },
    ];

    return (
      <div>
        <Breadcrumbs breadcrumbs={breadcrumbs} />
        {heroImage && (
          <HeroStatic photos={heroImage} title={title}>
            <div className="sectionHeading">Student Information</div>
            <h1 className="heroH1" data-test-id="customTitle">
              {title}
            </h1>
            <p className="mt-1 mt-lg-2 heroHeadline" dangerouslySetInnerHTML={{ __html: entry.description! }} />
          </HeroStatic>
        )}
        <div className="section">
          <div className="container">
            <div className="articleBody">
              <div dangerouslySetInnerHTML={{ __html: entry.body! }} />
            </div>
          </div>
        </div>
        {!!moreItems?.length && (
          <div className="section">
            <div className="container">
              <h2 className="center">Student Information</h2>
              <div className="row cardsWrapper">
                {moreItems.map((item) => item && <StudentCard key={item.uid!} item={item} />)}
              </div>
            </div>
          </div>
        )}
      </div>
    );
  }

  return <NotFoundPage />;
};

StudentInformationPage.getInitialProps = ({ req }: NextPageContext) => ({
  slug: req?.url?.substring(req?.url?.lastIndexOf('/') + 1).replace(/\?.*$/, ''),
});

export default StudentInformationPage;
